import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Col, FormSelect, Row } from 'shards-react'
import { setFormData, performanceActions } from '../../../../redux/reducers/Performance/performanceReducer'
import { organizationList } from '../../../../redux/reducers/organization-list-reducer'
import { getYearsList } from '../../../../utils/smallHelpers'
import { ORG_TYPES } from '../../../../constants/const'
import styles from '../styles.module.css'


const Form = ({ form }) => {

  const yearsList = getYearsList(2025, 2027)

  const dispatch = useDispatch()

  const orgList = useSelector(state => state.reports.orgList.data)
  const auth = useSelector(state => state.auth.data)

  useEffect(() => {
    if (orgList !== undefined && orgList.length === 0) {
      dispatch(organizationList.organizationListRequestStart(auth))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    dispatch(setFormData({ ...form, [name]: value }))
  }

  const onSubmit = () => {
    dispatch(performanceActions.performanceRequestStart())
  }

  return (
    <Row className={styles.formRow}>

      <Col md={2}>
        <label htmlFor='year'>Выберите год</label>
        <FormSelect
          id='year'
          name='year'
          size='sm'
          value={form.year}
          onChange={handleChange}
        >
          {yearsList.map(year => <option key={year} value={year}>{year}</option>)}
        </FormSelect>
      </Col>

      <Col md={5}>
        <label htmlFor='idOrg'>Выберите организацию</label>
        <FormSelect
          id='idOrg'
          name='idOrg'
          size='sm'
          className='d-block'
          value={form.idOrg}
          onChange={handleChange}
        >
          <option value='0'>Все организации</option>
          {!!orgList && orgList.map(item => (
            <option key={item.idOrganization} value={item.idOrganization}>
              {item.orgName}
            </option>
          ))}
        </FormSelect>
      </Col>

      <Col md={2}>
        <label htmlFor='school'>Тип ОО</label>
        <FormSelect
          id='school'
          name='school'
          size='sm'
          className='d-block'
          value={form.school}
          onChange={handleChange}
        >
          {ORG_TYPES.map(({ name, value }) => <option key={value} value={value}>{name}</option>)}
        </FormSelect>
      </Col>

      <Button style={{ margin: '0 15px' }} onClick={onSubmit}>Создать отчет</Button>

    </Row>
  )
}

export default Form
